import { useIssueNotificationsQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { IssueNotificationsContext } from './types'
import { useRecipientsFn } from 'components/CIMSNotifications/hooks/useRecipientsFn'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } =
  createStrictContext<IssueNotificationsContext>('IssueNotificationsContext')

export const useIssueNotificationsContext = useContextFn

const IssueNotificationsProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const { data, loading, refetch } = useIssueNotificationsQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  const recipients = useRecipientsFn({
    data,
    getter: (id, { issueNotifications }) =>
      issueNotifications.records.find(
        ({ notificationEventId }) => id === notificationEventId
      )?.recipients,
    fallback: {
      __typename: 'IssueNotificationRecipients',
      every: null,
      byIssueType: [],
    },
  })
  return (
    <Provider
      value={{
        refetch,
        loading,
        notifications: data?.issueNotifications.records ?? [],
        types: data?.issueTypes.records ?? [],
        recipients,
      }}
    >
      {children}
    </Provider>
  )
}

export default IssueNotificationsProvider
